import { get } from 'lodash';
import React, { useEffect } from 'react';
import YouTube from 'react-youtube';

const defaultProps = {
  playerVars: {
    autoplay:1,
    controls: 0,
    disablekb: 1,
    iv_load_policy: 3,
    modestbranding: 0,
    rel: 0,
    showInfo: 0,
  },
};

export const Media = ({ onEnd, url, type, settings}) => {
  const props = {playerVars:{...defaultProps.playerVars,...settings}};

  useEffect(()=>{
    if(get(props,'playerVars.autoplay') !== 1)return;
    const view= document.getElementById('root');
    view.click();
  },[]);

  return (
    <>
      {type==='youtube'&&url&&<YouTube
        iframeClassName="embed-player"
        onEnd={()=>onEnd()}
        videoId={(url?url.split('v=')[1].split('&')[0]:'')}
        opts={props}
      />}
    </>
  );
};
